<div class="layout-footer back-footer mt-8">
    <img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'ClaroBlanco' : 'ClaroBlanco'}}.svg" alt="Logo" height="21"/>
    <span class="ml-2 pt-2">Aplicaciones Corporativas TI CENAM © </span>
</div>
